import { EventEmitter } from '@angular/core';

export abstract class BaseMenu {
	public readonly closed$$ = new EventEmitter<void>();
	public readonly opened$$ = new EventEmitter<void>();

	abstract open(): void;
	abstract close(): void;
}
